import { render, staticRenderFns } from "./FotoPendukungPresignedUrl.vue?vue&type=template&id=e8dd1e60&"
import script from "./FotoPendukungPresignedUrl.vue?vue&type=script&lang=js&"
export * from "./FotoPendukungPresignedUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports